export default __webpack_public_path__ + "static/media/Screenshot1.5eaad153.png";